import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus, Check } from "lucide-react";
import { Reveal, EASE } from "./motion";
import { DR_DAS_PROFILE } from "../lib/constants";

export const DasProfile = () => {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <div className="space-y-4" data-testid="das-profile">
      {DR_DAS_PROFILE.map((cat, i) => {
        const open = openIdx === i;
        return (
          <Reveal key={cat.title} delay={i * 0.06}>
            <div
              className={`rounded-2xl border overflow-hidden transition-colors duration-300 ${
                open ? "border-ink/20 bg-white shadow-xl shadow-blue-900/5" : "border-slate-200 bg-white card-lift"
              }`}
            >
              <button
                className="w-full flex items-center justify-between gap-4 text-left p-6 sm:p-7"
                onClick={() => setOpenIdx(open ? -1 : i)}
                aria-expanded={open}
                data-testid={`das-profile-category-${i}`}
              >
                <span>
                  <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-aqua">
                    {String(i + 1).padStart(2, "0")} · {cat.items.length} areas
                  </span>
                  <span className="block mt-1.5 text-lg sm:text-xl font-extrabold text-ink">{cat.title}</span>
                  <span className="block mt-1 text-sm text-slate-500">{cat.blurb}</span>
                </span>
                <span
                  className={`shrink-0 w-10 h-10 rounded-full flex items-center justify-center transition-colors ${
                    open ? "bg-ink text-white" : "bg-brand-mist text-ink"
                  }`}
                  aria-hidden="true"
                >
                  {open ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                </span>
              </button>
              <AnimatePresence initial={false}>
                {open && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4, ease: EASE }}
                    className="overflow-hidden"
                  >
                    <ul className="px-6 sm:px-7 pb-7 space-y-2.5">
                      {cat.items.map((item) => (
                        <li
                          key={item}
                          className="flex items-start gap-2.5 rounded-xl bg-slate-50 border border-slate-100 px-4 py-3 text-sm font-semibold text-ink/85"
                        >
                          <Check className="w-4 h-4 text-aqua shrink-0 mt-0.5" aria-hidden="true" />
                          {item}
                        </li>
                      ))}
                    </ul>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </Reveal>
        );
      })}
    </div>
  );
};
